type MixpanelClient = typeof import("mixpanel-browser").default;

export class UserTracker {
  static isEnabled = false;

  private static mixpanelPromise: Promise<MixpanelClient> | null = null;

  private static loadMixpanel() {
    if (!this.mixpanelPromise) {
      this.mixpanelPromise = import("mixpanel-browser").then(
        (module) => module.default
      );
    }
    return this.mixpanelPromise;
  }

  static init() {
    void this.loadMixpanel().then((mixpanel) => {
      mixpanel.init("df0416fb84e5b50683fe03a515e8b48a", {});
      this.isEnabled = true;
    });
  }

  static track(eventName: string, properties: any = {}) {
    if (!this.isEnabled) {
      return;
    }
    void this.loadMixpanel().then((mixpanel) => {
      mixpanel.track(eventName, properties);
    });
  }

  static reset() {
    if (!this.isEnabled) {
      return;
    }
    void this.loadMixpanel().then((mixpanel) => {
      mixpanel.reset();
    });
  }

  static identify(id: string) {
    if (!this.isEnabled) {
      return;
    }
    void this.loadMixpanel().then((mixpanel) => {
      mixpanel.identify(id);
    });
  }

  static setUserProperties(properties: any = {}) {
    if (!this.isEnabled) {
      return;
    }
    void this.loadMixpanel().then((mixpanel) => {
      mixpanel.register(properties);
      mixpanel.people.set(properties);
    });
  }
}
